import { Lock } from '@mui/icons-material';
import { InputLabel, OutlinedInput, TextField } from '@mui/material';
import { Field, ErrorMessage } from 'formik';

const TextInput = ({ customChange, preventFormikSetValue, helperText, floatingLabel = false, ...props }) => {
    return (
        <div>
            <InputLabel className="label">
                {props.label} {props.readOnly && <Lock fontSize="10px" style={{ marginBottom: '-2px' }} />} {props?.required && '*'}
            </InputLabel>
            <Field id={props.id} name={props.id} label={props.label}>
                {({ field, form }) => (
                    <div className="w-100">
                        <TextField
                            {...props}
                            id={props.id}
                            name={props.id}
                            label={floatingLabel ? props.label : null}
                            disabled={props.disabled}
                            type={props.type || 'text'}
                            required={props.required}
                            placeholder={props?.placeholder || `Enter ${props.label}`}
                            InputProps={{ readOnly: props.readOnly, ...props.InputProps }}
                            inputProps={{
                                ...props.inputProps,
                                style: { padding: '11px 14px', fontSize: '12px' },
                                autoComplete: props?.autoComplete ? 'on' : 'new-password',
                                form: {
                                    autoComplete: props?.autoComplete ? 'on' : 'off',
                                },
                            }}
                            multiline={props.multiline}
                            minRows={props.minRows}
                            variant="outlined"
                            fullWidth
                            error={Boolean(form.errors[props.id] && form.touched[field.name])}
                            value={props.value || field.value}
                            className={`${props.className}`}
                            onChange={({ target }) => {
                                const value = target.value || '';
                                if (!preventFormikSetValue) form.setFieldValue(field.name, value, false);
                                if (customChange) customChange(field.name, value);

                                if (value) {
                                    form.setTouched({ ...form.touched, [field.name]: false });
                                } else if (props?.required && !props?.readOnly) {
                                    form.setTouched({ ...form.touched, [field.name]: true });
                                }
                            }}
                            onBlur={() => {
                                form.setTouched({ ...form.touched, [field.name]: true });
                            }}
                            helperText={form.errors[props.id] && form.touched[field.name] ? form.errors[props.id] : helperText || ''}
                        />
                    </div>
                )}
            </Field>
        </div>
    );
};

export default TextInput;
